import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable()
export class AppLoadService {

    constructor(
        private authService: AuthService
    ) { }

    public returnPromise = () => {

        {
            if (window.location.href.indexOf('lxp-user-redirected-from-new-bp=true') > -1) {
                this.addDomainToLXPList();
            }
        }
        const queryParamKey = 'leap_authorization_code';
        const consumeToken = this.getQeueryParameterByName(queryParamKey);
        if (this.authService.canForceLogin() && !consumeToken)
            return Promise.resolve(this.authService.forceLogin());
        const nonce = this.authService.getNonce();

        // Clear Authorization_code & Nonce
        this.authService.deleteNonce();
        const url = new URL(window.location.href);
        if (consumeToken) {
            url.searchParams.delete(queryParamKey);
            window.history.replaceState({ path: url.toString() }, document.title, url.toString());
        }

        let promise;
        if (consumeToken && nonce) {
            promise = this.consumeCredentials(consumeToken, nonce).toPromise();
        } else if (this.authService.tokensExist()) {
            promise = this.validateAccessToken().toPromise();
        } else {
            promise = new Promise((resolve) => {
                if (this.isPublicPage()) return resolve();

                document.location.replace(`${window.location.origin}#/welcome`);
                location.reload();
            })
        }

        return promise.catch(_ => {
            this.authService.clearSession();
            this.authService.logout();
            return;
        });
    }

    initAuthStatus(): Observable<any> {
        return Observable.of();
    }

    consumeCredentials(consumeToken: string, nonce: string): Observable<any> {
        return this.authService.consumeCredentials(consumeToken, nonce)
            .map(_ => _.json())
            .map(({ accessToken, refreshToken }) => {
                this.authService.setSession(accessToken, refreshToken);
                return { accessToken, refreshToken };
            })
    }

    validateAccessToken(): Observable<any> {
        return this.authService.validateAccessToken();
    }

    getQeueryParameterByName(name) {
        const url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    isPublicPage() {
        let publicRoutes = [
            '#/welcome',
            '#/self-register',
            '#/register-with-voucher',
            '#/support',
            '#/privacy',
            '#/register',
            '#/evaluation'
        ];
        let result = false;
        publicRoutes.forEach(_ => {
            if (window.location.hash.startsWith(_)) {
                result = true;
                return;
            };
        });

        return result;
    }

    addDomainToLXPList() {
        const lxpDomains = (window.localStorage.getItem('lxp-domain-list') || '').split(', ');
        if (!this.isLXPUser()) {
            lxpDomains.push(this.parseDomain());
            window.localStorage.setItem('lxp-domain-list', lxpDomains.join(', '))
        }

    }

    isLXPUser() {
        const lxpDomains = (window.localStorage.getItem('lxp-domain-list') || '').split(', ');
        return lxpDomains.indexOf(this.parseDomain()) >= 0;
    }

    parseDomain(): string {

        let rootDomains = ['.dev.congolo.com', '.test.congolo.com', '.itpx.one', '.stage.congolo.com', '.congolo.com', '.campus.itpreneurs.com', '.leapest.com', '.leapestpreview.com', '.edcastmarketplace.com'];
        let domain = window.location.hostname;

        rootDomains.forEach(function (rd) {
            domain = domain.replace(rd, '');
        });

        return domain;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/app-load.service.ts